module.exports = __webpack_public_path__ + "static/media/casa-adobe-360-preview.83dc1fd9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/casa-adobe-360-preview.JPG
// module id = 1157
// module chunks = 0